import ServerSideChangedNotificationsEvent from '@/services/ServerEventService/events/ServerSideChangedNotificationsEvent';
import ServerSideChangedUserRoleEvent from '@/services/ServerEventService/events/ServerSideChangedUserRoleEvent';
import ServerSideChangedUserStatusEvent from '@/services/ServerEventService/events/ServerSideChangedUserStatusEvent';
import ServerSideCommonEvent from '@/services/ServerEventService/events/ServerSideCommonEvent';
import ServerSideCurrentNotificationsEvent from '@/services/ServerEventService/events/ServerSideCurrentNotificationsEvent';
import ServerSideDisabledEditModeEvent from '@/services/ServerEventService/events/ServerSideDisabledEditModeEvent';
import ServerSideDisabledUserEvent from '@/services/ServerEventService/events/ServerSideDisabledUserEvent';
import ServerSideEnableEditModeEvent from '@/services/ServerEventService/events/ServerSideEnableEditModeEvent';
import ServerSideEnabledUserEvent from '@/services/ServerEventService/events/ServerSideEnabledUserEvent';
import ServerSideNewNotificationsEvent from '@/services/ServerEventService/events/ServerSideNewNotificationsEvent';
import ServerSideNotificationEvent from '@/services/ServerEventService/events/ServerSideNotificationEvent';

export const ServerSideConnectionEvents = {
  Common: ServerSideCommonEvent,
  Notification: ServerSideNotificationEvent,
};

export const ServerSideEvents = {
  ChangedNotifications: ServerSideChangedNotificationsEvent,
  ChangedUserRole: ServerSideChangedUserRoleEvent,
  ChangedUserStatus: ServerSideChangedUserStatusEvent,
  CurrentNotifications: ServerSideCurrentNotificationsEvent,
  DisabledEditMode: ServerSideDisabledEditModeEvent,
  DisabledUser: ServerSideDisabledUserEvent,
  EnabledUser: ServerSideEnabledUserEvent,
  EnableEditMode: ServerSideEnableEditModeEvent,
  NewNotifications: ServerSideNewNotificationsEvent,
  Notification: ServerSideNotificationEvent,
};
